import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Cube = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 20rem;
	background: ${({ background }) => background};
	color: #000;
`;
